import React from 'react'

import PopoverOnClick from 'components/Utils/Popover/PopoverOnClick'
import NoteControlsMenu from 'components/Notes/Controls/Menu'
import IconButton from 'components/Utils/IconButton'
import { MoreIcon } from 'components/Utils/Icons'

export default function MetaMore({ noteId }) {
  return (
    <PopoverOnClick
      position="left"
      align="start"
      content={({ closePopover }) => (
        <NoteControlsMenu
          noteId={noteId}
          placement="left"
          onRowClick={closePopover}
        />
      )}
    >
      <IconButton tooltip="More" tooltipPosition="left">
        <MoreIcon size={16} />
      </IconButton>
    </PopoverOnClick>
  )
}
